module.exports = __webpack_public_path__ + "02f4de59cedac129689d505718fff68b.svg";